import CyrusCoin from './CyrusCoin/CyrusCoin'
import './App.css';

function App() {
  return (
    <div className="App">
      <CyrusCoin />
    </div>
  );
}

export default App;
